import flight from 'flightjs'; // eslint-disable-line no-restricted-imports
import $ from 'jquery'; // eslint-disable-line no-restricted-imports

function Tags() {
    this.defaultAttrs({
        tagDelete: '[data-delete]',
        tagSelector: '[data-edit-tag]',
        tagTemplate: '[data-tag-template]',
        tagValue: '[data-tag-value]',
        tagSelected: '[data-selected]',
    });

    // Create existing tags, as soon as they are provided by tag-editor component
    this.createExistingTags = function(event, data) {
        data.existingTags.forEach(tagName => {
            if (tagName.length) {
                const $tag = this.getNewTag(tagName);
                this.insertTag($tag);
            }
        });
    };

    // Create a new tag
    this.getNewTag = function(tagName) {
        const $html = $(this.select('tagTemplate').html());
        $html.find(this.attr.tagValue).text(tagName);
        return $html;
    };

    // Insert tag into tag container
    this.insertTag = function($tag) {
        this.$node.append($tag);
    };

    // Get data from tag, then delete tag
    this.removeClickedTag = function(event, data) {
        this.removeTag(
            $(data.el.parentNode)
                .text()
                .trim()
        );
    };

    // Get data from event, then delete tag
    this.removeTagByName = function(event, data) {
        this.removeTag(data.value);
    };

    // Remove tag from tag container and form field as soon as it's clicked
    this.removeTag = function(tagName) {
        const $tag = this.$node.find(`:contains(${tagName})`);
        $tag.remove();
        this.trigger('uiTagDeleted', {
            tagName,
        });
    };

    // Remove all tags
    this.removeAllTags = function() {
        const self = this;
        this.select('tagSelected').each(function() {
            self.removeTag(
                $(this)
                    .text()
                    .trim()
            );
        });
    };

    // Replace all selected tags with new tag list
    this.replaceTags = function(event, data) {
        const self = this;
        const tags = data.tags || [];
        this.select('tagSelector').remove();
        tags.forEach(tag => {
            const $tag = self.getNewTag(tag.value);
            self.insertTag($tag);
        });
    };

    // User selected a suggestion
    this.suggestionsSelected = function(event, data) {
        const tagName = data.tagName;
        const $tag = this.getNewTag(tagName);

        this.insertTag($tag);
        this.trigger('uiAddTagNameToForm', {
            tagName,
        });
    };

    this.after('initialize', function() {
        // Create inital tag list in display when existing tags are available
        this.on('uiExistingTagsAvailable', this.createExistingTags);

        // Create a new tag when user made a selections on suggestions list
        this.on('uiSuggestionsSelected', this.suggestionsSelected);

        // Delete tag if another component requests
        this.on(document, 'uiDeactivateFilter', this.removeTagByName);

        // Delete all tags
        this.on(document, 'uiRemoveAllTags', this.removeAllTags);

        // Replace all inputs and tags with new data
        this.on('uiReplaceTags', this.replaceTags);

        // Remove tag from display when user clicks it
        this.on('click', {
            tagDelete: this.removeClickedTag,
        });
    });
}

export default flight.component(Tags);



// WEBPACK FOOTER //
// ./src/js/component_ui/tag-display.js